import React from 'react';
import TextInput from '../Common/TextInput';
import Label from '../Common/Label';
import './addArtistInfo.css';
import Button from '../Common/Button';

class AddArtistInfo extends React.Component {

    state = {
        name: '',
        townCity: '',
        country: '',
        imageUrl: '',
        trackList: []
    };

    changeField = (field) => {
        return (value) => {
            console.log('setting', field, 'as', value)
            let state = {...this.state};
            state[field] = value
            this.setState({ ...state });
        }
    }

    onSubmit = () => {
        this.props.updateArtistInfo(this.state);
    }

    render() {
        console.log('state;', this.state)
        return(
            <div className="addArtistInfo">
                <div className="addArtistInfo__title">Artist Info</div>

                <form onSubmit={this.onSubmit}>
                    <div className="addArtistInfo__field">
                        <Label>Artist Name</Label>
                        <div className="addArtistInfo__Input">
                            <TextInput value={this.state.name} onChange={this.changeField('name')} />
                        </div>
                    </div>
                    <div className="addArtistInfo__field">
                        <Label>Town/City</Label>
                        <div className="addArtistInfo__Input">
                            <TextInput value={this.state.townCity} onChange={this.changeField('townCity')} />
                        </div>
                    </div>
                    <div className="addArtistInfo__field">
                        <Label>Country</Label>
                        <div className="addArtistInfo__Input">
                            <TextInput value={this.state.country} onChange={this.changeField('country')} />
                        </div>
                    </div>
                    <div className="addArtistInfo__field">
                        <Label>ImageUrl</Label>
                        <div className="addArtistInfo__Input">
                            <TextInput value={this.state.imageUrl} onChange={this.changeField('imageUrl')} />
                        </div>
                    </div>
                    {this.state.imageUrl && (
                        <div>
                            <img src={this.state.imageUrl} alt="artist" />
                        </div>
                    )}
                    <div className="addArtistInfo__submitButton">
                        <Button type="submit">Save</Button>
                    </div>
                </form>
            </div>
        );
    }
}

export default AddArtistInfo;